import { render, staticRenderFns } from "./operatingCurrentAccount.vue?vue&type=template&id=9670a1c0"
import script from "./operatingCurrentAccount.vue?vue&type=script&lang=js"
export * from "./operatingCurrentAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports